import { render, staticRenderFns } from "./CustomDialog.vue?vue&type=template&id=e73da08c&scoped=true&"
import script from "./CustomDialog.vue?vue&type=script&lang=ts&"
export * from "./CustomDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CustomDialog.vue?vue&type=style&index=0&id=e73da08c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73da08c",
  null
  
)

export default component.exports